import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function CyberSecurity() {
  useEffect(() => {
    document.title = "Cyber Security Solutions for Businesses: Digital Protection";
        sal();
      }, []);
    const [expanded, setExpanded] = useState({});
        const toggleReadMore = (key) => {
        setExpanded((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

  return (
    <>
    <Helmet>
        <title>Cyber Security Solutions for Businesses: Digital Protection</title>
        <meta name="description" content="Safeguard your business from cyber threats with cutting-edge cyber security solutions. Protect data and stay compliant with expert-driven protection services." />
        <meta name="keywords" content="Cyber Security, Cyber Security Threats, Cyber Security Services, Cyber Security For Business, Cyber Security threat intelligence" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/cyber-security`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/cyber-security`} />
        <meta property="og:title" content="Cyber Security Solutions That Secure Your Brand from Threats" />
        <meta property="og:description" content="Stay ahead of cyber risks with powerful cyber security services. From threat prevention to data protection, secure your digital operations with confidence." />
    </Helmet>
    <section className="banner-bg bg-dark ssl-banner">
        <div className="container">
            <div className="row align-items-center g-4">
                <div className="col-lg-6">
                    <div className="pb-40">
                        <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Security That Makes No Noise</span>
                        <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Cyber Security: Helps You Dream Peacefully</h1>
                        <p className="text-white mb-8 max-text-60 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Is your cyber security powerful enough to safeguard your data, users, and systems daily? Cyber security is the one that plays a noteworthy role in avoiding any type of data breach, protecting networks, and guaranteeing business continuity in a growing digital landscape.
                        </p>
                        <Link to="/frequently-asked-questions" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <span className="btn-arrow__text">
                                Learn More
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
                <div className="col-lg-6 col-xxl-6 ipad-mt"><div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"><img alt="image" className="img-fluid full-width-img" src="/images/cyber-security-that-works.webp"/></div></div>
            </div>
        </div>
    </section>

    <section className="simple-box-section position-relative z-1 overflow-hidden">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-10">
                        <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                            <div className="card-body pt-60 pb-60">
                                <div className="row justify-content-center">
                                <div className="col-md-11 col-lg-10 col-xl-10">
                                    <div className="text-center">
                                        <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">More Than Just Basic</span>
                                        <h4 className="mb-4">
                                            Cyber Security For Business That’s Low-Key Doing Better than Ordinary
                                        </h4>
                                        <p className="mb-6">
                                            What really stops modern problems from turning into big issues? Cyber security for business that truly works behind the scenes (BTS) to safeguard networks, apps, and data before risks are out of control. It helps brands to remain secure and focused on real work.
                                        </p>
                                        <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                            <span className="d-inline-block me-1 flex-shrink-0">
                                                <i className="las la-comments"></i>
                                            </span>
                                            <span className="btn-arrow__text">
                                                +91-7737300013
                                                <span className="btn-arrow__icon">
                                                    <i className="fa-solid fa-arrow-right"></i>
                                                </span>
                                            </span>
                                        </Link>
                                        <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                            <span className="d-inline-block me-1 flex-shrink-0">
                                                <i className="las la-comments"></i>
                                            </span>
                                            <span className="btn-arrow__text">
                                                Talk to an Expert
                                                <span className="btn-arrow__icon">
                                                    <i className="fa-solid fa-arrow-right"></i>
                                                </span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>

    <section className="pt-100 pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    </div>
                    <div className="text-center mb-8">
                    <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">The Cyber Security Threats You Don’t See… </h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                    <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                        <h6 className="text-dark mb-0">Phishing Attacks</h6>
                        <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                    </div>
                    <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                        <div className="flex-shrink-0">
                            <img src="/images/phishing-attacks.webp" alt="icon" className="img-fluid" />
                        </div>
                        <div>
                            <p className={`feature-text mb-0 ${expanded.wp ? "expanded" : ""}`}>
                            Phishing attacks usually begin with just a simple text message that looks like any other normal message, but isn’t. Disguised as legal emails or different links, these threats depend completely on human-based errors to slip into organizational systems and access personal data.
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={() => toggleReadMore("wp")}
                            >
                            {expanded.wp ? "Read less" : "Read more"}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
                
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                    <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                        <h6 className="text-dark mb-0">Malware</h6>
                        <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                    </div>
                    <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                        <div className="flex-shrink-0">
                            <img src="/images/malware.webp" alt="icon" className="img-fluid" />
                        </div>
                        <div>
                            <p
                            className="feature-text mb-0"
                            style={{ maxHeight: expanded.ecom ? "1000px" : "4.5em" }}
                            >
                            Malware is the one that hides in all those places that look totally secure-attachments, downloads, or familiar sites. After getting all access, it can instantly slow down systems, interfere with processes, or expose sensitive business data over time.
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={() => toggleReadMore("ecom")}
                            >
                            {expanded.ecom ? "Read less" : "Read more"}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
                
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                    <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                        <h6 className="text-dark mb-0">Ransomware</h6>
                        <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                    </div>
                    <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                        <div className="flex-shrink-0">
                            <img src="/images/ransomware.webp" alt="icon" className="img-fluid" />
                        </div>
                        <div>
                            <p
                            className="feature-text mb-0"
                            style={{ maxHeight: expanded.software ? "1000px" : "4.5em" }}
                            >
                            Ransomware is one of the most popular cyber security threats that easily turns daily business systems unreachable within a very short time. Locking all essential data, websites, and applications, it interrupts crucial processes and places high pressure on businesses to easily restore access and resume everyday activity.
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={() => toggleReadMore("software")}
                            >
                            {expanded.software ? "Read less" : "Read more"}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
            
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                    <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                        <h6 className="text-dark mb-0">Unauthorized Access</h6>
                        <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                    </div>
                    <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                        <div className="flex-shrink-0">
                            <img src="/images/unauthorized-access.webp" alt="icon" className="img-fluid" />
                        </div>
                        <div>
                            <p
                            className="feature-text mb-0"
                            style={{ maxHeight: expanded.unauthorized ? "1000px" : "4.5em" }}
                            >
                            What generally makes unauthorized access so hard to find out? As a cyber security threat, it starts with compromised authorizations and gives cyber attackers silent entry into business systems, where they can get full access to your data and interrupt processes without instant detection.
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={() => toggleReadMore("unauthorized")}
                            >
                            {expanded.unauthorized ? "Read less" : "Read more"}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                    <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                        <h6 className="text-dark mb-0">Data Breaches</h6>
                        <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                    </div>
                    <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                        <div className="flex-shrink-0">
                            <img src="/images/data-breaches.webp" alt="icon" className="img-fluid" />
                        </div>
                        <div>
                            <p
                            className="feature-text mb-0"
                            style={{ maxHeight: expanded.breaches ? "1000px" : "4.5em" }}
                            >
                            What really happens when your personal data falls into a hacker’s hands? Data breaches are kinds of cyber security threats that expose enterprises' or customers' details to unauthorized members, impacting maintained trust, compliance, and the future-proof credibility of a business.
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={() => toggleReadMore("breaches")}
                            >
                            {expanded.breaches ? "Read less" : "Read more"}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
            
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                    <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                        <h6 className="text-dark mb-0">Denial-of-Service (DoS) Attacks</h6>
                        <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                    </div>
                    <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                        <div className="flex-shrink-0">
                            <img src="/images/denial-of-service.webp" alt="icon" className="img-fluid" />
                        </div>
                        <div>
                            <p
                            className="feature-text mb-0"
                            style={{ maxHeight: expanded.dos ? "1000px" : "4.5em" }}
                            >
                            What takes place when systems are highly flooded with more traffic than they can manage? DoS attacks are cyber security threats that flood networks and servers, making available services slow or quite unavailable and interrupting productivity, UX, and business continuity.
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={() => toggleReadMore("dos")}
                            >
                            {expanded.dos ? "Read less" : "Read more"}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>

            </div>
        </div>
    </section>


    <section className="bg-light-13 pt-100 pb-100">
    <div className="container">
        <div className="row">
            <div className="col-xl-9">
                <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Cyber Safety That Really Works</small>
                <h2 className="mb-0">Cyber Security Best Practices & Prevention Measures</h2>
            </div>
        </div>
        <div className="mt-12">
            <div className="row g-4">
                <div className="col-lg-12">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="card h-100">
                                <div className="card-body p-xl-6">
                                <img src="/images/strong-password-access-controls.webp" alt="Image" className="img-fluid mb-5"/>
                                <h6 className="mb-5">Strong Password and Access Controls</h6>
                                <p className="mb-0">Use a mixture of special characters, numbers, and letters as your password, and enable access controls, powered by cybersecurity threat intelligence, to block unknown entries.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card h-100">
                                <div className="card-body p-xl-6">
                                <img src="/images/regular-system-updates.webp" alt="Image" className="img-fluid mb-5"/>
                                <h6 className="mb-5">Regular System Updates & Patch Management</h6>
                                <p className="mb-0">Always keep your software, applications, and systems up-to-date as the key part of your cyber security for business tactics to prevent attackers from using known vulnerabilities.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card h-100">
                                <div className="card-body p-xl-6">
                                <img src="/images/employee-awareness-security-training.webp" alt="Image" className="img-fluid mb-5"/>
                                <h6 className="mb-5">Employee Awareness & Security Training</h6>
                                <p className="mb-0">Turn your professionals into your first line of high protection with everyday training on different attacks like phishing, safe browsing, and secure data management.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card h-100">
                                <div className="card-body p-xl-6">
                                <img src="/images/monitoring-threat-detection.webp" alt="Image" className="img-fluid mb-5"/>
                                <h6 className="mb-5">Monitoring and Threat Detection</h6>
                                <p className="mb-0">Always stay in the lead of cyber threats with real-time security monitoring and careful attack detection that identifies suspicious activity before damage occurs.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </section>

      <div className="pb-40">
        <div className="pb-40">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/cyber-security-for.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Small Business, Big Security 
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Cyber Security for Small Businesses?? Done, Right!!
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Have you considered how well-protected your small business truly is? Cyber threats don’t just wait to scale-they strike where security is a little fragile. That’s why cyber security for business is centered on developing unbeatable online defenses. Ranging from protecting customer data to stopping illegal access and avoiding expensive downtime, the right cyber security solutions help you stay secure, professional, and prepared.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-10">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Looking for Advanced Cyber Security?
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Can Your Large Business Handle a Cyber Attack?
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Cyber threats don’t knock politely-they directly break in. That is the case for why cyber security for business is engineered to safeguard all challenging networks, personal data, and mission-critical processes in real time. With the help of advanced threat detection and enterprise-level security, your business stays flexible and trusted and always remains in the lead of modern risks-so growth never slows down.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/can-your-large.webp" alt="image" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section className="pt-40 pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                    <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>What We Offer
                    </small>
                    </div>
                    <div className="text-center mb-8">
                    <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Designed for Security. Built for Business.</h2>

                    </div>
                </div>
            </div>
            <div className="row g-4">
                
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                    <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                        <h6 className="text-dark mb-0">Data Protection & Privacy</h6>
                        <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                    </div>
                    <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                        <div className="flex-shrink-0">
                            <img src="/images/protected-in.webp" alt="icon" className="img-fluid" />
                        </div>
                        <div>
                            <p className={`feature-text mb-0 ${expanded.wp ? "expanded" : ""}`}>
                            Your data tells your story-don’t always let it fall into unreliable hands. Ranging from customer details to essential files, we protect what matters most with cutting-edge access controls, encryption, and cautious security. The outcome? Exceptional security, reliable compliance, and full freedom.
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={() => toggleReadMore("wp")}
                            >
                            {expanded.wp ? "Read less" : "Read more"}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
                
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                    <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                        <h6 className="text-dark mb-0">Security Risk Assessment & Gap</h6>
                        <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                    </div>
                    <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                        <div className="flex-shrink-0">
                            <img src="/images/security-that-always.webp" alt="icon" className="img-fluid" />
                        </div>
                        <div>
                            <p
                            className="feature-text mb-0"
                            style={{ maxHeight: expanded.ecom ? "1000px" : "4.5em" }}
                            >
                            Know where you stand before any threat takes place. Our security risk assessment shows all hidden vulnerabilities and essential gaps across your chosen systems, helping you strengthen fragile points before they become main issues. With real-time insights and valuable recommendations, you stay secure and always in the lead.
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={() => toggleReadMore("ecom")}
                            >
                            {expanded.ecom ? "Read less" : "Read more"}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
                
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                    <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                        <h6 className="text-dark mb-0">Identity & Access Management</h6>
                        <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                    </div>
                    <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                        <div className="flex-shrink-0">
                            <img src="/images/identity-&-access.webp" alt="icon" className="img-fluid" />
                        </div>
                        <div>
                            <p
                            className="feature-text mb-0"
                            style={{ maxHeight: expanded.software ? "1000px" : "4.5em" }}
                            >
                            Give the right access to the right people. Identity & access management helps control who can enter your systems, safeguarding personal data while keeping teams efficient. With our highly secure authentication, you decrease ongoing risk, avoid unnecessary entry, and maintain full visibility across your online environment.
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={() => toggleReadMore("software")}
                            >
                            {expanded.software ? "Read less" : "Read more"}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
            
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                    <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                        <h6 className="text-dark mb-0">Cybersecurity Strategy and Governance</h6>
                        <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                    </div>
                    <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                        <div className="flex-shrink-0">
                            <img src="/images/cyber-security-strategy.webp" alt="icon" className="img-fluid" />
                        </div>
                        <div>
                            <p
                            className="feature-text mb-0"
                            style={{ maxHeight: expanded.infra ? "1000px" : "4.5em" }}
                            >
                            Strong cyber security always begins with a detailed plan. Cybersecurity strategy & governance meet your people to engineer an exceptional security structure. Ranging from setting different policies to managing adherence and risk, we help guide your organization with well-organized oversight.
                            </p>
                            <button
                                className="read-more-btn"
                                onClick={() => toggleReadMore("infra")}
                            >
                            {expanded.infra ? "Read less" : "Read more"}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
    
    </>
  );
}
